import { getProgramsWithPreparedLLPACaps } from 'app/pages/loanApplication/Validation/ChooseProgramPopup/ChooseProgramPopup.utils';
import _ from 'lodash';

import { LoanOptionVendorType } from 'constants/company';
import { LoanOptionPriceStatus, TBD_AFTER_SAVE } from 'constants/programs';
import { getConditionalObject } from 'utils/data';

import { getLoanOptionPendingData } from '../ProgramDetails/components/RateTableCell/RateTableCell.utils';

export const getIsProgramExpired = ({ loanOption, isEnableLocking }) =>
  isEnableLocking &&
  loanOption?.vendorType === LoanOptionVendorType.OPTIMAL_BLUE &&
  loanOption?.priceStatus === LoanOptionPriceStatus.EXPIRED;

export const getCurrentLoanProgramOption = ({
  loanProgramOptions,
  llpaTypesValues,
  selectedLoanProgramOption,
  pendingChanges,
  application,
  programDetails,
  isOBEngineType,
}) => {
  const currentProgramId = programDetails.program?.programId;
  const { loanOptionId, programId } = selectedLoanProgramOption || {};

  const isStubLoanOption = loanProgramOptions.length === 1 && !!loanProgramOptions[0].isStubOption;
  const isSelectedNonParOption = programId === programDetails.program?.programId && !loanOptionId;

  if (isStubLoanOption) {
    return {
      currentLoanProgramOption: loanProgramOptions[0],
      isSelectedLoanProgramOption: false,
    };
  }

  const preparedCurrentLoanProgramOptions = getProgramsWithPreparedLLPACaps(
    llpaTypesValues,
    loanProgramOptions,
  );

  const preparedLoanProgramOption = _.find(preparedCurrentLoanProgramOptions, { loanOptionId });

  const fallbackProgramId = _.get(
    pendingChanges,
    'programId.newValue',
    application?.[isOBEngineType ? 'productId' : 'programId'],
  );

  const isSelectedLoanProgramOption = selectedLoanProgramOption
    ? programId === currentProgramId
    : fallbackProgramId === currentProgramId;

  const newPendingLoanProgramOption = preparedCurrentLoanProgramOptions.find(
    rowData =>
      getLoanOptionPendingData({
        pendingChanges,
        application,
        ...rowData,
      }).isNewLoanOptionId,
  );

  const selectedRate =
    selectedLoanProgramOption?.rate || _.get(pendingChanges, 'rate.newValue', application?.rate);

  const selectedRateOverride = getConditionalObject(selectedRate && isSelectedLoanProgramOption, {
    rate: selectedRate,
  });

  // Option ids regenerate on every pricing search, so the loan's stored rung is re-found by RATE
  // when the id no longer matches. Only the loan's own program row gets this match; comparison rows
  // keep their own par option.
  const rateMatchedLoanProgramOption =
    selectedRate && isSelectedLoanProgramOption
      ? _.find(preparedCurrentLoanProgramOptions, { rate: selectedRate })
      : null;

  // The row must stay a single coherent option — overriding only the rate onto the par option
  // fabricated a rung the current sheet doesn't offer (rate 6% with the 5.875 option's APR/payment/
  // credit). When the loan's stored rate left the sheet, today's par option is shown instead; the
  // loan's committed terms remain on the loan header and Loan Info.
  const baseLoanProgramOption =
    preparedLoanProgramOption ||
    newPendingLoanProgramOption ||
    rateMatchedLoanProgramOption ||
    preparedCurrentLoanProgramOptions[0];

  if (isSelectedNonParOption) {
    return {
      currentLoanProgramOption: {
        ..._.pick(preparedCurrentLoanProgramOptions[0], [
          'lenderName',
          'internalName',
          'vendorType',
          'searchId',
        ]),
        ...selectedLoanProgramOption,
        ...selectedRateOverride,
        apr: TBD_AFTER_SAVE,
        paymentMonth: TBD_AFTER_SAVE,
        pmi: 0,
      },
      isSelectedLoanProgramOption,
    };
  }

  return {
    currentLoanProgramOption: baseLoanProgramOption,
    isSelectedLoanProgramOption,
  };
};
